(function () {
  if (window.bsImageDragInstalled) return;
  window.bsImageDragInstalled = true;

  const prepared = new WeakMap();
  const desktopViewport = window.matchMedia('(min-width: 750px)');
  let active = null;
  let dragging = false;

  function visibleAt(image, x, y) {
    const box = image.getBoundingClientRect();
    const style = getComputedStyle(image);
    return box.width > 0 && box.height > 0 && x >= box.left && x <= box.right &&
      y >= box.top && y <= box.bottom && style.visibility !== 'hidden' &&
      style.display !== 'none' && Number(style.opacity) >= 0.5;
  }

  function candidate(target, x, y) {
    if (!(target instanceof Element)) return null;
    if (active?.proxy.contains(target)) return active.source;
    const modal = target.closest('product-modal[open]');
    if (modal) return Array.from(modal.querySelectorAll('img.active[data-media-id]'))
      .find((image) => visibleAt(image, x, y)) || null;
    const main = target.closest('media-gallery[data-product-slider] .swiper-slide-active .product__modal-opener--image');
    if (main && !target.closest('button')) return Array.from(main.querySelectorAll('.product__media img'))
      .find((image) => visibleAt(image, x, y)) || null;
    const thumbnail = target.closest('.thumbnail');
    if (thumbnail) return Array.from(thumbnail.querySelectorAll('img:not(.bs-image-drag-proxy)'))
      .find((image) => visibleAt(image, x, y)) || null;
    const related = target.closest('.bs-related-products__card');
    if (related) return Array.from(related.querySelectorAll('.bs-related-products__image'))
      .find((image) => visibleAt(image, x, y)) || null;
    const card = target.closest('.product-card-wrapper');
    if (!card || target.closest('button, input, select, textarea')) return null;
    return Array.from(card.querySelectorAll('.card__media img')).reverse()
      .find((image) => visibleAt(image, x, y)) || null;
  }

  function imageData(image) {
    const src = image.currentSrc || image.src;
    const cached = prepared.get(image);
    if (cached?.originalSrc === src) return cached;
    const url = new URL(src, location.href);
    const extension = url.pathname.match(/\.(jpe?g|png)$/i)?.[1]?.toLowerCase();
    const filename = decodeURIComponent(url.pathname.split('/').pop());
    const result = { originalSrc: src, src, type: null, filename };
    if (extension && image.naturalWidth * image.naturalHeight <= 16000000) {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const context = canvas.getContext('2d');
        if (!context) return result;
        context.drawImage(image, 0, 0);
        const type = extension === 'png' ? 'image/png' : 'image/jpeg';
        const encoded = canvas.toDataURL(type, 0.95);
        if (encoded.startsWith(`data:${type};base64,`)) {
          result.src = encoded;
          result.type = type;
          result.filename = filename.replace(/\.(jpe?g|png)$/i, type === 'image/png' ? '.png' : '.jpg');
        }
      } catch (error) {
        // A restricted source still gets native image drag rather than a text link.
      }
    }
    prepared.set(image, result);
    return result;
  }

  function clear() {
    if (!active) return;
    active.proxy.remove();
    if (active.restorePosition) active.host.style.position = active.oldPosition;
    active = null;
  }

  function show(image) {
    if (active?.source === image && active.originalSrc === (image.currentSrc || image.src)) return;
    clear();
    if (!image?.isConnected || !image.complete || !image.naturalWidth || !image.naturalHeight) return;
    const host = image.closest('.product-media-modal__dialog, .product__modal-opener--image, .thumbnail, .bs-related-products__image-wrap, .product-card-wrapper');
    if (!host) return;
    const data = imageData(image);
    const box = image.getBoundingClientRect();
    const hostBox = host.getBoundingClientRect();
    const style = getComputedStyle(image);
    const proxyImage = document.createElement('img');
    const mainImage = host.matches('.product__modal-opener--image');
    proxyImage.className = `bs-image-drag-proxy${mainImage ? ' swiper-no-swiping' : ''}`;
    proxyImage.alt = image.alt || '';
    proxyImage.draggable = true;
    proxyImage.src = data.src;
    if (mainImage) {
      proxyImage.style.cursor = 'copy';
      proxyImage.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (dragging) return;
        clear();
        host.querySelector('.product__media-toggle')?.click();
      });
    }
    Object.assign(proxyImage.style, {
      display: 'block', width: '100%', height: '100%', maxWidth: 'none', maxHeight: 'none',
      objectFit: style.objectFit, objectPosition: style.objectPosition,
      borderRadius: style.borderRadius, margin: '0', pointerEvents: 'auto',
    });
    let proxy = proxyImage;
    const cardLink = host.matches('.product-card-wrapper')
      ? host.querySelector('.card__heading a[href]') : null;
    if (cardLink) {
      proxy = document.createElement('a');
      proxy.href = cardLink.href;
      proxy.tabIndex = -1;
      proxy.append(proxyImage);
    }
    proxy.setAttribute('aria-hidden', 'true');
    Object.assign(proxy.style, {
      position: 'absolute', left: `${box.left - hostBox.left - host.clientLeft + host.scrollLeft}px`,
      top: `${box.top - hostBox.top - host.clientTop + host.scrollTop}px`,
      width: `${box.width}px`, height: `${box.height}px`, zIndex: mainImage ? '1' : '10',
    });
    const oldPosition = host.style.position;
    const restorePosition = getComputedStyle(host).position === 'static';
    if (restorePosition) host.style.position = 'relative';
    active = { proxy, proxyImage, source: image, host, oldPosition, restorePosition, ...data };
    host.append(proxy);
  }

  // A real JPEG <img> lets the browser create its native image/file drag payload.
  function trackPointer(event) {
    if (dragging) return;
    if (!desktopViewport.matches || event.pointerType !== 'mouse') { clear(); return; }
    const image = candidate(event.target, event.clientX, event.clientY);
    if (image) show(image);
    else clear();
  }
  document.addEventListener('pointerover', trackPointer, true);
  document.addEventListener('pointermove', trackPointer, true);
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') clear();
  }, true);
  desktopViewport.addEventListener('change', clear);
  document.addEventListener('dragstart', (event) => {
    if (!active || event.target !== active.proxyImage || !event.dataTransfer) return;
    dragging = true;
    event.dataTransfer.setData('text/plain', '');
    event.dataTransfer.clearData('text/uri-list');
    if (active.type) event.dataTransfer.setData('DownloadURL', `${active.type}:${active.filename}:${active.src}`);
    event.dataTransfer.effectAllowed = 'copy';
  }, true);
  document.addEventListener('dragend', () => { dragging = false; clear(); }, true);
  document.addEventListener('scroll', () => { if (!dragging) clear(); }, true);
  document.addEventListener('shopify:section:unload', clear);
  document.body.addEventListener('modalClosed', clear);
  window.addEventListener('resize', clear);
  window.addEventListener('blur', () => { if (!dragging) clear(); });
  window.addEventListener('pagehide', clear);
})();
